// Environment detection for the operator-facing env banner.
//
// The SPA has no API-surfaced manager-mode field: GET /auth/me returns only
// {user, expiresAt} (see OperatorSessionResponse in types.ts), and the
// gateway's MANAGER_MODE env var is server-side only. The reliable signal
// available to the browser is the hostname the SPA is served from:
//   manage.convenely.local  → local dev/devcontainer
//   manage.convenely.net    → production
// Anything else (e.g. a preview/staging host, or jsdom in tests) falls back
// to 'local' so an unrecognized host never masquerades as production.

export type Environment = 'local' | 'production';

const PRODUCTION_HOSTNAME = 'manage.convenely.net';

/** Resolve which manager environment the SPA is currently running in. */
export function getEnvironment(): Environment {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  return hostname === PRODUCTION_HOSTNAME ? 'production' : 'local';
}
